export default __webpack_public_path__ + "static/media/error-img.989b4481.png";